import {Exclude, Expose, instanceToPlain, plainToClass} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../web/validation";
import {Entity} from "./entity";
import {RouteArrayValidator} from "./route";

export const RouteGroupValidator = t.intersection([
  t.type({
    id: t.string,
    name: t.string,
    regionId: t.string,
  }),
  t.partial({
    routes: RouteArrayValidator,
    createDttm: t.number,
    lastModifiedDttm: t.number,
  }),
]);

export const RouteGroupArrayValidator = t.array(RouteGroupValidator);

export type RouteGroup = t.TypeOf<typeof RouteGroupValidator>;
export type RouteGroupArray = t.TypeOf<typeof RouteGroupArrayValidator>;

@Exclude()
export class RouteGroupEntity implements Entity {
  @Expose()
  id!: string;

  @Expose()
  name!: string;

  @Expose()
  regionId!: string;

  @Expose()
  createDttm?: number;

  @Expose()
  lastModifiedDttm?: number;

  readonly entityType = 'ROUTEGROUP';

  get displayName(): Readonly<string> {
    return this.name;
  }

  /**
   * Constructor for RouteGroupEntity. Recommend using the {@link create} method instead.
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  static from(pipelineFlow: RouteGroup): RouteGroupEntity {
    return plainToClass(RouteGroupEntity, pipelineFlow, {
      excludeExtraneousValues: true,
    });
  }

  loadTypeValue(): Promise<RouteGroup> {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSON(RouteGroupValidator, object);
  }

  asTypeValue(): RouteGroup {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSONNow(RouteGroupValidator, object);
  }
}
